import { render, staticRenderFns } from "./Labeltemplate.vue?vue&type=template&id=615ad6c4&scoped=true"
import script from "./Labeltemplate.vue?vue&type=script&lang=js"
export * from "./Labeltemplate.vue?vue&type=script&lang=js"
import style0 from "./Labeltemplate.vue?vue&type=style&index=0&id=615ad6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ad6c4",
  null
  
)

export default component.exports